// extracted by mini-css-extract-plugin
export var dropdown = "_td-0";
export var imageWrapper = "_td-3";
export var itemNameContainer = "_td-1";
export var productImage = "_td-2";
export var spinnerWrapper = "_td-4";